export const regularizacaoTitulosStyle = {}
